import React from 'react'
import { globals, s, colors, alpha } from '../../style'
import { T } from '../../typo'
import { ButtonMain } from '../../buttons'
import cracktop from '../../assets/cracktop'
import mockupsvg from '../../assets/mockup.svg'

const IntroSimple = ({ theme, data }) => {
  const {
    subtitleString,
    titleString,
    description,
    buttonCall,
    slug_section,
  } = data

  // console.log(typeof description)

  return (
    <section css={sSection}>
      <span css={sCrack(theme)}>{cracktop}</span>
      <div css={sContainer} id={slug_section}>
        <div css={[sTextContainer]}>
          <T
            m={24}
            d={32}
            mb={1}
            upper
            condensed
            extraCss={[sSubtitle, sTextTheme(theme)]}>
            {subtitleString}
          </T>
          <div
            css={{
              position: 'relative',
              // marginBottom: '2rem',
              [s.xs]: { left: 15 },
              [s.sm]: { left: 60 },
              [s.md]: { left: 60 },
              [s.lg]: { left: 60 },
              perspective: 400,
              width: 'max-content',
            }}>
            <T
              xs={56}
              sm={72}
              md={72}
              lg={72}
              xl={72}
              upper
              extraCss={[sTitle, sTextTheme(theme)]}>
              {titleString.split('.pl')}
              <span css={{ fontWeight: 300 }}>
                {titleString.slice(titleString.length - 3)}
              </span>
            </T>
          </div>
          <T
            variant="h1"
            d={16}
            m={16}
            extraCss={[
              {
                [s.sm_down]: {
                  width: '100%',
                  padding: '2rem 0 3rem',
                },
                [s.md]: {
                  width: '75%',
                  padding: '4rem 0',
                },
                lineHeight: '1.618em',
                [s.ss]: {
                  fontSize: 14,
                },
              },
              theme === 'dark' && { opacity: 0.6 },
            ]}>
            {description}
          </T>

          <ButtonMain
            link={`tel:${buttonCall.phone}`}
            theme={theme}
            uppercase
            isPhone>
            {buttonCall.text}
          </ButtonMain>
        </div>
        <div css={sMockupContainer}>
          <img src={mockupsvg} alt="crushed phone" css={sImage} />
        </div>
      </div>
    </section>
  )
}

const sCrack = (theme) => ({
  pointerEvents: 'none',
  width: '100%',
  height: '100%',
  position: 'absolute',
  transform: 'translate(0%, 0%)',
  opacity: 0.16,
  [s.xs]: {
    bottom: 0,
    left: '-100%',
    transform: 'translate(-50%, 0%) scale(0.5)',
  },
  [s.sm]: {
    top: '10%',
    left: -900,
  },
  [s.md]: {
    top: '10%',
    left: -900,
  },
  [s.lg]: {
    top: '25%',
    left: -800,
  },
  [s.xl]: {
    top: '25%',
    left: -850,
    transform: 'translate(0%, 0%) scale(1.25)',
    // opacity: 0.16,
  },
  'svg, path, g': {
    fill: theme === 'light' ? 'black' : 'white',
  },
  // mixBlendMode: 'overlay',
  // zIndex: 1001,
})

const sImage = {
  position: 'absolute',
  // backgroundColor: 'red',
  // transform: 'scale(0.5)',

  height: 'auto',
  [s.xs]: {
    width: '100%',
    top: '-20%',
    left: '54%',
    transform: 'translate(-50%, 0)',
  },
  [s.sm]: {
    width: '75%',
    top: '-20%',
    left: '54%',
    transform: 'translate(-50%, 0)',
  },
  [s.md]: {
    width: '100%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scale(1)',
  },
  [s.lg]: {
    top: '8%',
    width: '100%',
    // bottom: '-33%',
    left: '50%',
    transform: 'translate(-50%, 0) scale(1)',
  },
}

const sMockupContainer = {
  position: 'relative',
  // backgroundColor: 'rgba(0,255,0,1)',

  [s.sm_down]: {
    width: '100%',
    height: '123vw',
  },
  [s.md]: {
    width: '50%',
  },
  height: '100%',
}

const sTitle = {
  fontWeight: 900,
  letterSpacing: '-0.105em',
  transform: 'rotateY(40deg)',
}

const sSubtitle = {
  fontWeight: 900,
  letterSpacing: '-0.105em',
}

const sTextTheme = (theme) => ({
  color: 'white',
  background:
    theme === 'light'
      ? `linear-gradient(45deg, ${colors[theme].text.concat(
          alpha[100]
        )}, ${colors[theme].main.concat(alpha[100])})`
      : `linear-gradient(45deg, ${colors.white.concat(
          alpha[100]
        )}, ${colors.white.concat(alpha[16])})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  width: 'max-content',
})

const sTextContainer = {
  position: 'relative',
  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: '2rem',
  height: '100%',
  minHeight: 700,
  [s.ss]: {
    padding: '1rem',
  },
  [s.sm_down]: {
    width: '100%',
    // height: '100vh',
  },
  [s.md]: {
    width: '50%',
  },

  // backgroundColor: 'rgba(255, 0, 0, 0.1)',
}

const sContainer = {
  // backgroundColor: 'rgba(255, 255, 0, 0.1)',
  // display: 'flex',
  position: 'relative',
  width: '100vw',
  maxWidth: 1440,

  margin: '0 auto',
  display: 'flex',
  flexWrap: 'wrap',
  [s.sm_down]: {
    top: -globals.menu.height.mobile,
    // flexDirection: 'column',
    // minHeight: '100vh',
  },
  [s.md]: {
    top: -globals.menu.height.desktop,
    flexDirection: 'row',
    height: '100vh',
  },
}

const sSection = {
  // [s.sm_down]: { height: `calc(100vh - ${globals.menu.height.mobile}px)` },
  // [s.md]: { height: `calc(100vh - ${globals.menu.height.desktop}px)` },
  // height: 'max-content',
}

export default IntroSimple
